import { createSlice } from '@reduxjs/toolkit'

const defaultState = {
  displayCarriers: [],
}

export const airlines = createSlice({
  name: 'airlines',
  initialState: defaultState,
  reducers: {
    setDisplayCarriers(state, action) {
      state.displayCarriers = action.payload
    },
  },
})

export const { setDisplayCarriers } = airlines.actions
